import {Inject, Injectable} from '@angular/core';
import {AccountInfo, IPublicClientApplication, PopupRequest, RedirectRequest} from '@azure/msal-browser';
import {RedirectHandlerService} from '../../services/test/redirect-handler.service';
import {environment} from '../../../../environments/environment';
import {FormTypeEnum} from '../../../corporate/enums/form-type.enum';

@Injectable({
  providedIn: 'root'
})
export class CustomersLoginMsalService {

  private isInitialized = false;

  constructor(
    @Inject('MSAL_CUSTOMERS_LOGIN') private msal: IPublicClientApplication,
  ) {}

  private async init() {
    if (!this.isInitialized) {
      await this.msal.initialize();
      this.isInitialized = true;
    }
  }

  async redirectToSignUp(state: string,formType?: number) {
    await this.init();

    const request: RedirectRequest = {
      authority: this.setAuthorityType(formType),
      scopes: ['openid', 'profile', ...environment.apiConfig.customers_msal.scopes.write],
      prompt: 'login'
    };

    return this.msal.loginRedirect(request);
  }

  async logout() {
    await this.init();
    return this.msal.logoutRedirect({
      postLogoutRedirectUri: '/'
    });
  }

  private setAuthorityType(formType: number): string {
    switch (formType) {
      case FormTypeEnum.Individual:
        return environment.b2cCustomerPolicies.authorities.individualSignUpPolicyId.authority;
      case FormTypeEnum.Business:
        return environment.b2cCustomerPolicies.authorities.businessSignUpPolicyId.authority;
      default:
        return environment.b2cCustomerPolicies.authorities.signInPolicyId.authority;
    }
  }
}